import { WeekSchedule } from 'models/week-schedule';

export const GET_WEEK_SCHEDULE = 'GET_WEEK_SCHEDULE';
export const SELECT_LIST = 'SELECT_LIST';
export const TOGGLE_LIST = 'TOGGLE_LIST';
export const SET_DAY = 'SET_DAY';
export const REVERSE_CHANGES = 'REVERSE_CHANGES';
export const UPDATE_TABLE = 'UPDATE_TABLE';
export const LIST_DAY = 'LIST_DAY';
export const LIST_MOMENTS = 'LIST_MOMENTS';

interface getWeekSchedule {
  type: typeof GET_WEEK_SCHEDULE;
  payload: { weekSchedule: Array<WeekSchedule> };
}

interface setListSelected {
  type: typeof SELECT_LIST;
  payload: any;
}

interface toggleList {
  type: typeof TOGGLE_LIST;
  payload: any;
}

interface setDay {
  type: typeof SET_DAY;
  payload: any;
}

interface reverseChanges {
  type: typeof REVERSE_CHANGES;
  payload: any;
}

interface updateTable {
  type: typeof UPDATE_TABLE;
  payload: any;
}

export type WeekScheduleActions =
  | getWeekSchedule
  | setListSelected
  | setDay
  | toggleList
  | reverseChanges
  | updateTable;
